var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGeneratingvisualerror(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 120,
    viewBox: "0 0 118 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59 120C91.5848 120 118 104.649 118 85.7126C118 66.7761 91.5848 51.425 59 51.425C26.4152 51.425 0 66.7761 0 85.7126C0 104.649 26.4152 120 59 120Z",
    fill: "#F1C5C6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.694 98.1855L57.9396 20.8415C58.7874 18.6736 61.4585 17.8967 63.3368 19.2716C63.4982 19.3898 63.5605 19.6015 63.4887 19.7883L30.7774 104.892C30.5915 105.375 29.9892 105.539 29.5839 105.216C27.4809 103.54 26.7147 100.69 27.694 98.1855Z",
    fill: "#CFD5DD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7797 22.3814C60.7475 19.8706 63.1671 18.4646 64.1349 19.8504L95.4378 64.6755C96.4056 66.0613 95.1958 69.1998 93.2602 70.3247L32.832 105.442C29.9286 107.129 28.1139 104.53 29.5656 100.764L59.7797 22.3814Z",
    fill: "#F3F4F6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3751 63.2105C62.412 63.8435 62.8818 64.0795 63.4488 63.75C64.0151 63.4209 64.4845 62.6406 64.5225 61.9651L65.4045 46.2853V38.9546C65.4045 37.714 64.5349 37.2135 63.4622 37.8369C62.3895 38.4603 61.5199 39.9714 61.5199 41.2121V48.5428L62.3751 63.2105ZM61.4336 71.5401C61.4336 72.8451 62.3483 73.3715 63.4766 72.7158C64.6049 72.0601 65.5196 70.4706 65.5196 69.1656V68.9916C65.5196 67.6866 64.6049 67.1602 63.4766 67.8159C62.3483 68.4716 61.4336 70.0611 61.4336 71.3661V71.5401Z",
    fill: "#576579"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneratingvisualerror);
export default __webpack_public_path__ + "static/media/generatingvisualerror.9a3c59fd0560e5eb62eaa738edf9c8c6.svg";
export { ForwardRef as ReactComponent };